export enum FORM_FIELD_ENABLED_DISABLED {
    ENABLED = 'Y',
    DISABLED = 'N',
}

export enum VALIDATION {
    REQUIRED = 'required',
    PATTERN = 'pattern',
    MAX_LENGTH = 'maxlength',
    MIN_LENGTH = 'minlength',
}

// Below enum is used for the different types of fields in the form
export enum FORM_FIELD_TYPE_ENUM {
    TEXT = 'text',
    UNIQUE_TEXT = 'unique_text',
    NUMBER_FIELD = 'number_field',
    SINGLE_SELECT = 'single_select',
    ADD_EDIT_SINGLE_SELECT = 'add_edit_single_select',
    MULTI_SELECT_WITH_COMMA_SEPARATED = 'multi_select_with_comma_separated',
    MULTI_SELECT = 'multi_select',
    RADIO_BUTTONS = 'radio_buttons',
    SLIDE_TOGGLE = 'slide_toggle',
    CUSTOMISE_FIELD = 'customise_field_btn',
    TEXT_AREA = 'text_area',
    HORIZONTAL_LINE = 'horizontal_line',
    IMAGE_CROPPER = 'image_cropper',
    PHONE_NUMBER_FIELD = 'phone_number_field',
    TIME_PICKER_FIELD = 'time_picker',
    DATE_PICKER_FIELD = 'date_picker',
    DATE_TIME_RANGE_PICKER = 'date_time_picker',
    COLOR_PICKER = 'color_picker',
    PARENT_OF_DEPENDENT_DROPDOWN = 'parent_of_dependent_dropdown',

    CARD_WITH_SINGLE_SELECTION_AND_CRUD = 'card_with_single_selection_and_crud',
    CARD_WITH_MULTI_SELECTION_AND_CRUD = 'card_with_multi_selection_and_crud',
    USE_TEMPLATE_FLOW = 'use_template_flow',
    ROLE_SIDE_NAVIGATION = 'role_side_navigation',
    ROLE_MODULE_PERMISSION = 'role_module_permission',
    SUBSCRIPTION_PLAN = 'subscription_plan',
    SUBSCRIPTION_PRICING_ROW_CALCULATION = 'subscription_pricing_row_calculation',
    SUBSCRIPTION_PLAN_LIST = 'subscription_plan_list',
    ADDING_INFO = 'adding-info',
}
